import { extends as _extends, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { TableContainer, Box, Table, TableRow, TableCell } from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import { TableVirtuoso } from 'react-virtuoso';
const VirtuosoTableComponents = () => ({
  Scroller: /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React__default.createElement(TableContainer, _extends({
    component: Box
  }, props, {
    ref: ref
  }))),
  Table: () => /*#__PURE__*/React__default.createElement(Table, {
    size: "small",
    style: {
      tableLayout: 'fixed'
    }
  })
});
function CohortTable(_ref) {
  let {
    data,
    color,
    width,
    unit,
    tableHeight
  } = _ref;
  const hexToRGB = hex => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return {
      r,
      g,
      b
    };
  };
  const {
    r,
    g,
    b
  } = hexToRGB(color);
  const calculatePercentage = (value, baseValue) => baseValue ? (value / baseValue * 100).toFixed(1) : '0.0';
  const getBackgroundColor = percentage => {
    try {
      const alpha = percentage / 100;
      return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
    } catch (error) {
      console.warn('Invalid color format, using default color');
      const defaultColor = hexToRGB('#7b61ff');
      const alpha = percentage / 100;
      return "rgba(".concat(defaultColor.r, ", ").concat(defaultColor.g, ", ").concat(defaultColor.b, ", ").concat(alpha, ")");
    }
  };
  const values = Object.keys(data);
  const basicCellStyle = {
    borderColor: 'white',
    backgroundColor: 'white',
    padding: '0px 12px',
    height: '36px',
    maxHeight: '36px',
    width: '70px',
    minWidth: '70px',
    maxWidth: '70px',
    borderRight: '1px solid white'
  };
  const fixedHeaderContent = () => /*#__PURE__*/React__default.createElement(TableRow, {
    style: {
      fontWeight: 'bold'
    }
  }, /*#__PURE__*/React__default.createElement(TableCell, {
    style: _objectSpread2(_objectSpread2({}, basicCellStyle), {}, {
      minWidth: '80px',
      width: '80px',
      maxWidth: '80px'
    })
  }), values.map((value, i) => /*#__PURE__*/React__default.createElement(TableCell, {
    key: "header-".concat(value),
    align: "center",
    style: _objectSpread2(_objectSpread2({}, basicCellStyle), {}, {
      color: '#A2A3A5',
      fontSize: '10px',
      whiteSpace: 'nowrap'
    })
  }, unit, " ", i + 1)));
  const rowContent = (index, value) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableCell, {
    component: "th",
    scope: "row",
    sx: _objectSpread2({
      fontWeight: 'medium',
      textAlign: 'right',
      color: '#A2A3A5',
      fontSize: '10px',
      minWidth: '80px',
      width: '80px',
      maxWidth: '80px',
      position: 'sticky',
      left: 0
    }, basicCellStyle)
  }, /*#__PURE__*/React__default.createElement(Box, {
    fontWeight: 700
  }, unit === 'Day' ? moment(value, 'DD-MM-YYYY').format('DD MMM') : value), /*#__PURE__*/React__default.createElement(Box, null, "(", data[value][0] || 0, ")")), data[value] && data[value].slice(1).map((columnValue, i) => {
    const baseValue = data[value][0];
    const percentage = calculatePercentage(columnValue, baseValue);
    return /*#__PURE__*/React__default.createElement(TableCell, {
      key: "cell-".concat(value, "-").concat(i),
      align: "center",
      style: _objectSpread2(_objectSpread2({}, basicCellStyle), {}, {
        fontSize: '12px',
        fontWeight: 500,
        backgroundColor: getBackgroundColor(percentage),
        color: 'black'
      })
    }, isNaN(percentage) ? 'N/A' : "".concat(percentage, "%"));
  }));
  return /*#__PURE__*/React__default.createElement(TableVirtuoso, {
    key: unit,
    data: values,
    style: {
      maxWidth: width,
      height: tableHeight,
      backgroundColor: 'white',
      borderRadius: '8px',
      overflow: 'auto'
    },
    components: /*#__PURE__*/React__default.createElement(VirtuosoTableComponents, {
      width: width,
      tableHeight: tableHeight
    }),
    fixedHeaderContent: fixedHeaderContent,
    itemContent: rowContent
  });
}
CohortTable.propTypes = {
  data: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))).isRequired,
  color: PropTypes.string,
  width: PropTypes.string,
  tableHeight: PropTypes.string,
  unit: PropTypes.string
};
CohortTable.defaultProps = {
  color: '#7b61ff',
  width: '100%',
  tableHeight: '300px',
  unit: 'Day'
};
export { CohortTable as default };